import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Grid, makeStyles, Typography, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Close } from '@material-ui/icons';
import CustomButtonIcon from '../../Common/ButtonIcon';
import NotificationEvents from '../Events';
import { UpdateNotificationRead } from '../../../hooks/eventNotifications';

const useStyles = makeStyles(theme => ({
  titleStyle: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '21.28px',
    paddingTop: '15px',
    color: theme.palette.type === 'dark' ? '#E9E9E9' : '#262626',
  },
  subtitleStyle: {
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '18.62px',
    color: theme.palette.type === 'dark' ? '#E9E9E9' : '#262626',
  },
  separatorStyle: {
    borderBottom: theme.palette.type === 'dark' ? '2px solid #BA68C8' : '2px solid #9C27B0',
    width: '96%',
  },
  closeButtonStyle: {
    color: theme.palette.type === 'dark' ? '#E1BEE7' : '#45505E',
  },
  normalContainer: {
    margin: '0px 5px 0px 5px !important',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? '#515151' : '#E9E9E98C',
      cursor: 'pointer',
    },
    paddingTop: '5px',
    borderRadius: '5px',
  },
  selectedContainer: {
    margin: '5px 5px 0px 5px !important',
    backgroundColor: theme.palette.type === 'dark' ? '#D1B9D6' : '#F6EBF8',
    borderRadius: '5px',
  },
}));

const KillshotNotificationsDrawer = props => {
  const { earlierData, newData, isFetching, setEarlierData, setNewData, setNotificationOpen } = props;
  const classes = useStyles();
  const history = useHistory();
  const { event_id: eventIdPath } = useParams();
  const [selected, setSelected] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleClose = () => {
    setNotificationOpen(false);
    setSelected(null);
    setSelectedIndex(null);
  };

  const handleOnclickContainer = (dataSection, index, eventId, notificationId) => {
    if (dataSection === 'new') {
      const updatedNotificationsData = [...newData];
      updatedNotificationsData[index].isRead = true;
      setNewData(updatedNotificationsData);
      setSelectedIndex(index);
      setSelected(dataSection);
    } else {
      const updatedNotificationsData = [...earlierData];
      updatedNotificationsData[index].isRead = true;
      setEarlierData(updatedNotificationsData);
      setSelectedIndex(index);
      setSelected(dataSection);
    }
    history.push(`/event/pricing/${eventId}`);
    UpdateNotificationRead(notificationId);
    // Set timestamp for latest notification read to update tabs whenever they became active again
    localStorage.setItem('latest_notification', Date.now());
    if (parseInt(eventId, 10) === parseInt(eventIdPath, 10)) {
      window.location.reload();
    }
  };

  return (
    <>
      <div style={{ marginBottom: '15px' }}>
        <Grid
          container
          style={{
            paddingLeft: '10px',
            marginTop: '4px',
          }}
        >
          <Grid item xs={12}>
            <Grid container direction="row" alignContent="flex-end">
              <Grid>
                <Typography className={classes.titleStyle}>Notifications</Typography>
              </Grid>
              <Grid item>
                <></>
              </Grid>
              <Grid item style={{ paddingRight: '5px' }}>
                <CustomButtonIcon size="small" onClick={() => handleClose()} width="30px" height="30px">
                  <Close className={classes.closeButtonStyle} style={{ fontSize: '18px' }} />
                </CustomButtonIcon>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div style={{ height: '100%', overflow: 'auto' }}>
        <Grid
          container
          style={{
            paddingLeft: '10px',
          }}
        >
          <Grid item xs={12}>
            {newData.length === 0 && earlierData.length === 0 ? (
              <Grid container>There are no new notifications</Grid>
            ) : (
              <Grid container>
                {newData && newData.length > 0 && (
                  <Grid item xs={12}>
                    <Typography className={classes.subtitleStyle}>New</Typography>
                    <div className={classes.separatorStyle} />
                  </Grid>
                )}
                {isFetching ? (
                  <div>
                    <Grid item xs={3}>
                      <CircularProgress />
                    </Grid>
                  </div>
                ) : (
                  newData &&
                  newData.length > 0 &&
                  newData.map((eventData, index) => (
                    <Grid
                      item
                      className={
                        selectedIndex === index && selected === 'new'
                          ? classes.selectedContainer
                          : classes.normalContainer
                      }
                      onClick={() => {
                        handleOnclickContainer('new', index, eventData.eventId, eventData.notificationId);
                      }}
                    >
                      <NotificationEvents
                        eventData={eventData}
                        selected={selectedIndex === index && selected === 'new'}
                      />
                    </Grid>
                  ))
                )}
                {earlierData && earlierData.length > 0 && (
                  <Grid item xs={12} style={{ marginTop: '15px' }}>
                    <Typography className={classes.subtitleStyle}>Earlier</Typography>
                    <div className={classes.separatorStyle} />
                  </Grid>
                )}

                {isFetching ? (
                  <div>
                    <Grid item xs={3}>
                      <CircularProgress />
                    </Grid>
                  </div>
                ) : (
                  earlierData &&
                  earlierData.length > 0 &&
                  earlierData.map((eventData, index) => (
                    <Grid
                      item
                      className={
                        selectedIndex === index && selected === 'earlier'
                          ? classes.selectedContainer
                          : classes.normalContainer
                      }
                      onClick={() => {
                        handleOnclickContainer('earlier', index, eventData.eventId, eventData.notificationId);
                      }}
                    >
                      <NotificationEvents
                        eventData={eventData}
                        selected={selectedIndex === index && selected === 'earlier'}
                      />
                    </Grid>
                  ))
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

KillshotNotificationsDrawer.propTypes = {
  earlierData: PropTypes.array.isRequired,
  newData: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  setEarlierData: PropTypes.func.isRequired,
  setNewData: PropTypes.func.isRequired,
  setNotificationOpen: PropTypes.func.isRequired,
};

export default KillshotNotificationsDrawer;
